<template>
    <b-card class="review-templates-view">
        <div class="form-sample viewcheckoff ">
            <div class="d-flex title-bar-block mb-2">
                <div class="icon-block me-4">
                    <button id="close-labe-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                        <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2">{{ $translate('review_templates') }}</span>
                </div>
            </div>
            <b-tabs card align="center" v-model="tabIdx">
                <b-tab :title="$translate('summary')" active class="p-0 mt-3">
                    <b-card-body class="p-0">
                        <b-overlay :show="loading" rounded="sm">
                            <b-form @submit.stop.prevent="onSubmit">
                                <b-row>
                                    <b-col>
                                        <label class="mb-3"><strong>{{ $translate('name') }}<span
                                                    class="red">*</span></strong></label>
                                        <b-form-input type="text" id="input-name" v-model="model.name" required v-custom-validation="$textRequired()"
                                            :placeholder="$translate('enter_name')" trim></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="mt-3">
                                        <label class="mb-3"><strong>{{ $translate('description') }}</strong></label>
                                        <b-form-input type="text" id="input-description" v-model="model.description"
                                            :placeholder="$translate('enter_description')" trim></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col class="mt-3">
                                        <label for="input-notify_users" class="mb-3">
                                            <strong>{{ $translate('roles_for_notification') }}</strong>
                                        </label>
                                        <multiselect id="input-checkoff_completion_notify_roles" :placeholder="$translate('select_the_roles_for_notification')" 
                                        v-model="model.checkoff_completion_notify_roles" 
                                        :options="roleOptions" 
                                        :searchable="true"
                                        :deselectLabel="deselectLabel" 
                                        :selectedLabel="selectedLabel" 
                                        :multiple="true" 
                                        :preserve-search="true"
                                        :selectLabel="selectLabel" 
                                        @remove="selectedRoles"
                                        @select="selectedRoles"
                                        label="name" track-by="id" :close-on-select="false">
                                            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></template>
                                        </multiselect>
                                    </b-col>
                                </b-row>
                                <b-col class="mt-4 d-flex gap-2">
                                    <div class="form-check me-2">
                                        <label class="form-check-label">
                                            <input type="checkbox" id="input-completed" v-model="model.completed"
                                                :unchecked-value="0" :value="1" />
                                            <i class="input-helper"></i>
                                        </label>
                                    </div>
                                    <label for="input-completed" class="mb-3"><strong>{{ $translate('completed') }}<span
                                                class="red">*</span></strong></label>
                                    <!-- </b-col>
                                <b-col class="mt-2"> -->
                                    <div class="form-check me-2">
                                        <label class="form-check-label">
                                            <input id="input-archived" type="checkbox" v-model="model.archived"
                                                :unchecked-value="0" :value="1" />
                                            <i class="input-helper"></i>
                                        </label>
                                    </div>
                                    <label for="input-archived" class="mb-3"><strong>{{ $translate('archived') }}<span
                                                class="red">*</span></strong></label>
                                </b-col>
                                <b-col class="mt-4 text-center">
                                    <b-button id="create-template-btn" class="btn btn-info btn-fw me-2" type="submit"
                                        v-if="hasPermissionCreate && !model.id" variant="primary"
                                        :disabled="loading ? true : false">{{ createLabel }}</b-button>
                                    <b-button id="update-template-btn" class="btn btn-info btn-fw me-2" type="submit"
                                        v-if="hasPermissionUpdate && model.id" variant="primary"
                                        :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                                    <b-button id="delete-template-btn" v-if="!!model.id && hasPermissionDelete" @click="deleteItem()" size="fw"
                                        class="me-2" variant="delete-button">
                                        {{ $deleteLabel() }}
                                    </b-button>
                                    <b-button id="cancel-template-btn" variant="info" class="me-2 btn-fw" :disabled="loading ? true : false"
                                        @click="cancel()">{{ $cancelLabel() }}</b-button>
                                    <!-- render the sumbit button only if the user can create and/or update -->
                                </b-col>
                            </b-form>
                        </b-overlay>
                    </b-card-body>
                </b-tab>
                <b-tab :title="$translate('processes')">
                    <b-card-body class="p-0">
                        <template-items v-if="tabIdx === 1" :template="template" />
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </div>
    </b-card>
</template>
<script>
//name, description, order_type_id, order_category_id
import Multiselect from 'vue-multiselect'
import TemplateItems from './TemplateItems'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

export default {
    name: 'reviewTemplates-ViewItem',
    components: {
        TemplateItems, Multiselect
    },
    mixins: [popupMixins, permissionsMixins, errorHandlingMixins],
    data() {
        return {
            model: {
                id: 0,
                name: null,
                description: null,
                archived: false,
                completed: false,
                items: [],
                checkoff_completion_notify_roles: [],
            },
            loading: false,
            hasErrors: false,
            tabIdx: 0,
            roleOptions: [],
        }
    },
    props: ['item'],
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            return !this.model.id ? true : false
        },
        /**
         * True if the user has permission to view but not update an order template and clicked the view button on a template in the table, otherwise false.
         */
        canView() {
            return this.model.id ? true : false
        },
        /**
         * True if the user has permission to update an order template and clicked the view button on a template in the table, otherwise false.
         */
        canUpdate() {
            return this.model.id ? true : false
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
        templates() {
            const templates = this.$store.state.checkoffTemplates.templates
            console.log('templates', templates)
            return templates
        },
        template() {
            return this.$store.state.checkoffTemplates.selectedTemplate
        },
        roles() {
            return this.$store.state.roles.items;
        },
    },
    watch: {
        item: function(value){
            console.log('value-', value)
        }
    },
    async mounted() {
        // ensure that the selected template and model are cleared for a new template or updated with an existing template
        if (this.item.id) {
            this.model = this.item
            await this.$store
                .dispatch('checkoffTemplates/fetchById', this.item.id)
                .then(() => {
                    this.model = this.template
                    this.model.checkoff_completion_notify_roles = this.model.notify_roles_upon_completion || []
                })
        } else {
            this.$store.dispatch('checkoffTemplates/newTemplate', this.model)
        }
        await this.$store.dispatch("roles/fetchAll")
        this.roleOptions = this.roles
        this.selectedRoles()
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        async onSubmit() {
            try {
                this.loading = true
                const model = { ...this.model }
                console.log('model', model)
                const action = model.id ? 'update' : 'create'
                const message = model.id ? this.$translate('update_alert') : this.$translate('create_alert')
                const path = `checkoffTemplates/${action}`
                const valid = await this.$validator.validate()
                if (!valid) throw new Error('Invalid Entry!')
                await this.$store.dispatch(path, model)
                this.$emit('success', action, message)
            } catch (error) {
                console.log('error', error)
                //this.doToast('Error Detected', error.message, 'warning')
                this.$emit('error', error, this.model.name)
            } finally {
                this.loading = false
            }
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'checkoffTemplates/delete'
            // const action = model.id ? 'update' : 'create'

            // Generate and display confirmation prompt
            const title = this.$translate('delete_review_template')
            const message = `${this.$translate('delete_note')} ${model.name}?`
            // const errorMsg = this.$translate('unable_alert')
            const alertMsg = this.$translate('delete_alert')
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.loading = true;
                    this.$store
                        .dispatch(path, model.id)
                        .then(() => {
                            this.loading = false;
                            this.$emit('success', this.$translate('delete'), alertMsg)
                        })
                        .catch(error => {
                            console.error(error)
                            this.loading = false;
                            this.doToast(
                                this.$translate('error'),
                                this.$translate('unable_alert'),
                                'danger'
                            )
                        })
                } else {
                    this.loading = false;
                }
            })            
        },
        selectedRoles() {
            this.roleOptions.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
            var selected = this.roleOptions.filter(s => this.model.checkoff_completion_notify_roles.some(item => s.id == item.id))
            var notSelected = this.roleOptions.filter(s => !this.model.checkoff_completion_notify_roles.some(item => s.id == item.id))
            this.roleOptions = [...selected, ...notSelected];
        }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style></style>
